
define('text!js-translation.json',[],function () { return '{"Add to Cart":"Add to basket","Bill cap":"Safety buffer","Clear all":"Reset","Gift Card %1 was added.":"Clubcard voucher code %1 successfully added.","Gift Card %1 was removed.":"Clubcard voucher code %1 successfully removed.","Proceed to Checkout":"Go to checkout","Sign In":"Log in"}';});

